<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <div class="text-center">
          <div class="display-1 my-3">404</div>
          <div class="display-2 my-3">Page not found</div>
          <div>return to <router-link to="/login" class="text--primary">login</router-link> page</div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data() {},
    computed: {},
    methods: {},
  }
</script>

<style scoped>
  .container {
    background-color: white;
  }
</style>


